import { Button } from "@/components/ui/button/button";
import { BwWaitListDark, BwWaitListLight } from "@/components/ui/icons";
import ThemeIcon from "@/components/ui/icons/theme-icon";
import { GeneralHeader } from "@/features/join/_components/general-header";

export function Waitlist() {
  return (
    <div className="sm:max-w-sm w-full mx-auto flex items-start flex-col mt-12 space-y-6">
      <ThemeIcon
        lightIcon={BwWaitListLight}
        darkIcon={BwWaitListDark}
        className="size-12"
      />

      <GeneralHeader
        title="We’ve got you on the list!"
        description="We’ll let you know as soon as we’re available in your area."
      />

      <Button
        kind={"solid"}
        className="w-full"
        onClick={() => (window.location.href = "https://birdwatch.com/")}
        size="xl"
      >
        Home page
      </Button>
    </div>
  );
}
